import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';

/**
 * Footer component
 */
class Footer extends React.Component {
  render() {
    return (
      <Box 
        component="footer" 
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          width: '100%',
          textAlign: 'center',
          fontSize: '0.875rem',
          color: 'white',
          background: 'linear-gradient(to right, #6c0c46, #8b1538)',
          py: { xs: 2, sm: 2.5 },
          boxShadow: '0 -2px 4px rgba(0,0,0,0.05)',
        }}
      >
        <Typography 
          variant="body2" 
          sx={{ 
            px: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
            fontSize: '0.75rem'
          }}
        >
          <Box component="span" sx={{ display: 'flex', alignItems: 'center' }}>
            © <Box component="span" sx={{ mx: 1 }}>{new Date().getFullYear()}</Box>
            <Link 
              href="https://www.astranahealth.com" 
              target="_blank" 
              rel="noopener noreferrer"
              sx={{ 
                color: 'white',
                textDecoration: 'underline',
                '&:hover': {
                  color: 'pink.200',
                  transition: 'colors 0.3s'
                }
              }}
            >
              Astrana Health, Inc.
            </Link>
          </Box>
          <Box component="span" sx={{ display: 'flex', alignItems: 'center' }}>
            <Box component="span" sx={{ mx: 2 }}>•</Box>
            Built with 
            <FavoriteIcon sx={{ mx: 1, color: '#ff0000', fontSize: '0.875rem' }} />
            by Astrana Product &amp; Engineering team
          </Box>
        </Typography>
      </Box>
    );
  }
}

export default Footer;
